import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";

interface CreatePromocodePayload {
  promoCodeId: string;
  promoCodeAmount: number;
  usageCount: number;
  validTo: string;
}

export const useCreatePromocode = () => {
  const { token } = useAuth();
  const fetch = useFetch();

  return useMutation({
    mutationFn: (data: CreatePromocodePayload) => {
      const response = fetch<void>("/booking/promocode", {
        method: "POST",
        body: JSON.stringify(data),
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
        }),
      }, true, token);

      return response;
    },
    onSuccess: () => {
      toast.success("Промокод успішно створено");
    },
    onError: (error) => {
      toast.error(error?.message || "Помилка при створенні промокоду");
    },
  });
};
